import { createSlice } from '@reduxjs/toolkit';
import CommonActions from '../actions/CommonActions';

/**
 *  Build state Alert Message
 *  Author: Oliver.Nguyen
 */
const initialState = {
  title : '',
  message: '',
  i18Message: '',
  params: [],
  isOpen: false,
  isOpenMessagePopup: false,
  okButton: null,
  cancelButton: null,
  remindButton: null,
  confirmAlert: false,
  className: '',
  backdropClass: '',
  bodyComponent: null, 
  isCloseLoginFailedCountNotify: false,
  closeButton: null,
  isModalMessageOpening: false
}
export const AlertSlice = createSlice({
    name: 'AlertSlice',
    initialState: initialState,
    reducers: {
      openAlert: (state, {payload}) => {
        state.title = payload.title ? payload.title : ''
        state.message =  payload.message
        state.params = payload.params ? payload.params : []
        state.okButton = {text: 'Ok', action: payload.fireEventKey}
        if (payload.fireCloseEventKey) {
          state.closeButton = {action: payload.fireCloseEventKey}
        }
        state.isOpen = true
        state.className = payload.className;
        state.backdropClass = payload.backdropClass ? payload.backdropClass : '';
        state.isCloseLoginFailedCountNotify = false
        CommonActions.inactiveScroll(true);
      },
      openModalMessage: (state, {payload}) => {
        state.title = payload.title ? payload.title : ''
        state.message =  payload.message
        state.params = payload.params ? payload.params : []
        state.okButton = {text: 'Ok', action: payload.fireEventKey}
        state.closeButton = {action: payload.fireCloseEventKey}
        state.isModalMessageOpening = true
        state.isOpen = true
        state.confirmAlert = true
        state.isCloseLoginFailedCountNotify = false
        state.backdropClass = payload.backdropClass ? payload.backdropClass : '';
        CommonActions.inactiveScroll(true);
      },
      opentConfirmAlert: (state, {payload}) => {
        state.title = payload.title ? payload.title : ''
        state.message = payload.message
        state.params = payload.params ? payload.params : []
        state.okButton = {text: 'Ok', action: payload.fireEventKey}
        state.cancelButton = {text: 'Cancel', action: null}
        state.isOpen = true
        state.confirmAlert = true 
        state.ataTransferButton = payload.ataTransferButton ? payload.ataTransferButton : null
        state.bodyComponent = payload.bodyComponent ? payload.bodyComponent : null
        state.isCloseLoginFailedCountNotify = false
        state.backdropClass = payload.backdropClass ? payload.backdropClass : '';
        CommonActions.inactiveScroll(true);
      },
      alert: (state, {payload}) => {
        if (payload.i18Message){
          state.i18Message =  payload.i18Message
        } else if (payload.message) {
          state.message =  payload.message
        }
        state.title = payload.title ? payload.title : ''
        state.params = payload.params ? payload.params : []
        state.okButton = payload.okButton
        state.cancelButton = payload.cancelButton ? payload.cancelButton : null
        state.remindButton = payload.remindButton ? payload.remindButton : null
        state.confirmAlert = payload.confirmAlert ? payload.confirmAlert : false
        state.notifyButton = payload.notifyButton ? payload.notifyButton : null
        state.closeButton = payload.closeButton || null
        state.isOpen = true
        state.isCloseLoginFailedCountNotify = false
        state.className = payload.className;
        state.backdropClass = payload.backdropClass ? payload.backdropClass : '';
        CommonActions.inactiveScroll(true);
      },
      closeAlert: state => {
        state.title =  null;
        state.message =  '';
        state.i18Message =  '';
        state.params =  [];
        state.okButton = null;
        state.cancelButton = null;
        state.remindButton = null;
        state.notifyButton = null;
        state.closeButton = null;
        state.ataTransferButton = null;
        state.isOpen = false;
        state.confirmAlert = false;
        state.isModalMessageOpening = false;
        state.bodyComponent = null;
        state.backdropClass = initialState.backdropClass;
        state.className = initialState.className;
        CommonActions.inactiveScroll(false);
      },
      closeLoginFailedCountNotify: state => {
        state.isCloseLoginFailedCountNotify = true;
      }
    }, 
  });
  
  export const {
    alert,
    openAlert,
    openModalMessage,
    opentConfirmAlert,
    closeAlert, 
    closeLoginFailedCountNotify
  } = AlertSlice.actions
  export const alertSelector = state => state.AlertSlice
  export default AlertSlice.reducer;


// WEBPACK FOOTER //
// ./src/app/slices/AlertSlice.js